export { default as Communication } from './page'


// WEBPACK FOOTER //
// ./src/pages/communication/index.js